import { ApplicationConfig } from '@angular/core';
import { importProvidersFrom } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateStore, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideState } from '@ngrx/store';
import { ColorThemeReducers } from '../store/color-theme/reducers';
import { ActiveLanguageReducers } from '../store/language/reducers';
import { provideIcons } from '@ng-icons/core';
import { bootstrapEyeFill } from '@ng-icons/bootstrap-icons';


export const authConfig: ApplicationConfig = {
  providers: [
    provideState("colorTheme", ColorThemeReducers),
    provideState("activeLanguage", ActiveLanguageReducers),
    importProvidersFrom(
      ReactiveFormsModule,
      TranslateModule.forChild({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideIcons({
      bootstrapEyeFill,
    }),
    TranslateStore,
  ]
};

export function httpLoaderFactory(_http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(_http, './assets/i18n/auth/auth-', '.json');
}
